import { create } from 'zustand';

const useTeamStore = create((set) => ({
  // State
  teams: [],
  teamsForDropdown: [],
  selectedTeam: null,
  selectedTeamLoading: false,
  loading: false,
  error: null,

  // Pagination & Sorting
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false
  },

  // Filters
  columnFilters: {},
  uniqueValues: {},

  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  teamToDelete: null,

  // Actions
  setTeams: (teams) => set({ teams }),
  setTeamsForDropdown: (teams) => set({ teamsForDropdown: teams }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setPaginationData: (data) => set({ paginationData: data }),
  setColumnFilters: (filters) => set({ columnFilters: filters }),
  setUniqueValues: (values) => set({ uniqueValues: values }),

  setSelectedTeam: (team) => set({ selectedTeam: team }),
  setSelectedTeamLoading: (selectedTeamLoading) => set({ selectedTeamLoading }),

  // UI Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedTeam: null
  }),

  openEditForm: (team) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedTeam: team
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedTeam: null
  }),

  openDeleteDialog: (team) => set({
    isDeleteDialogOpen: true,
    teamToDelete: team
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    teamToDelete: null
  }),

  reset: () => set({
    teams: [],
    teamsForDropdown: [],
    loading: false,
    error: null,
    columnFilters: {},
    selectedTeam: null,
    selectedTeamLoading: false,
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    teamToDelete: null
  })
}));

export { useTeamStore };
